import { supportsLinearEasing } from './basler-components.es773.js';
import { isGenerator } from './basler-components.es759.js';

function applyGeneratorOptions({ type, ...options }) {
    if (isGenerator(type) && supportsLinearEasing()) {
        return type.applyToOptions(options);
    }
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}

export { applyGeneratorOptions };
